module.exports = __webpack_public_path__ + "static/media/benchmark.a0584dd4.png";